import logo from '../assets/images/logo.png';

export class Constants {
    static appImages = {
        logo,
    }
}
